import { ModalTypes } from "../TargetTypeManagement";
import { getDeletePopup } from "../../../view/popup/PopupContainer";
import { removeGroupList } from "../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../validation/ToastContainer";

export class GroupManager {

    constructor(setModalProps, setModalType, setShowModal, setPopup, elements) {
        this.setShowProps = setModalProps;
        this.setModalType = setModalType;
        this.setShowModal = setShowModal;
        this.setPopup = setPopup;
        this.elements = elements;
    }

    showAddModal = () => {
        this.setModalType(ModalTypes.CREATE);
        this.setShowModal(true);
    }

    showEditModal = () => {

        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;

        const modalProps = {
            title: "Edit Group",
            text: "Select Groups",
            elements: this.elements,
            onClick: (element) => {
                setModalProps({ selectedGroup: element })
                setModalType(ModalTypes.EDIT);
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.SELECT);
        setShowModal(true);

    }

    showRemoveModal = () => {


        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;
        const setPopup = this.setPopup;

        const modalProps = {
            title: "Remove Group",
            text: "Select Groups",
            elements: this.elements,
            onSubmit: (groups) => {
                setPopup(
                    getDeletePopup('Are you sure you want to remove the selected groups?',
                        'Remove Groups',
                        () => removeGroupList(groups)
                            .then((errors) => {
                                setShowModal(false);
                                if (errors.length > 0) {
                                    errors.forEach(errMessage => {
                                        showDangerToast(errMessage, "Error", "Unable to delete Groups");
                                    })
                                } else {
                                    showSuccessToast("Groups were removed", "Remove Groups")
                                }
                            }),
                        undefined,
                        'Remove Groups'
                    ))
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.REMOVE);
        setShowModal(true);

    }
}
